<template>
    <resource-index :title="title" :endpoint="endpoint">
        <template slot="header-buttons">
            <router-link
                class="btn btn-secondary"
                :to="{
                    name: 'admin.products.categories.create',
                    params: {
                        parentId: this.parentId
                    }
                }"
            >Создать</router-link>
        </template>

        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Название</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.name" />
                </th>

                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">{{ slotProps.entry.name }}</td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.products.categories.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info"
                >Изменить</router-link>

                <router-link
                    :to="{
                        name: 'admin.products.index',
                        query: {
                            category: slotProps.entry.id
                        }
                    }"
                    class="btn btn-indigo"
                >Открыть</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    props: {
        parentId: [Number, String]
    },

    computed: {
        endpoint() {
            return this.parentId
                ? "admin/products/categories?filters[parent_id]=" +
                      this.parentId
                : "admin/products/categories?filters[parent]=1";
        },
        title() {
            return this.parentId ? "Подкатегории" : "Категории";
        }
    }
};
</script>